import type { ComponentPropsWithRef } from "react";
import { styled } from "styled-components";

import { ChevronIcon, UIButton } from "common/components";
import { Dropdown } from "common/components/dropdown/Dropdown";
import { breakpoints } from "common/styles";
import { useDispatch, useMemoisedSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { updateTransformationMapTopic } from "domains/transformationMap/actions";
import { getTmHistory } from "domains/transformationMap/selectors";
import { createTopicsSelector } from "entities/topics/selectors";

const StyledIcon = styled(ChevronIcon)`
  width: 14px;
  height: 14px;
  margin-left: 8px;
  transition: transform 0.3s ease-in-out;
`;

const StyledButton = styled(UIButton)<{ isActive?: boolean }>`
  display: none;
  color: ${({ isActive, theme }) => (isActive ? theme.colors.textBright : theme.colors.textFade)};
  background-color: ${({ theme }) => theme.colors.buttonNeutralBackground}b0;

  svg {
    transform: ${({ isActive }) => (isActive ? "rotate(270deg)" : "rotate(90deg)")};
  }

  @media ${breakpoints.large} {
    display: flex;
  }
`;

const Button = (props: ComponentPropsWithRef<"button">) => {
  const translate = useTranslate();

  return (
    <StyledButton {...props} variant="neutral">
      {translate("app.transformation_map.history")}
      <StyledIcon />
    </StyledButton>
  );
};

export const TransformationMapHistoryButton = () => {
  const dispatch = useDispatch();
  const history = useMemoisedSelector(getTmHistory, createTopicsSelector);

  const items = history
    .slice(1, 6)
    .map(({ id, name }) => ({ key: id, label: name, onClick: () => dispatch(updateTransformationMapTopic({ id })) }));

  return history.length > 0 ? <Dropdown alignment="right" ButtonElement={Button} items={items} /> : null;
};
